module.exports = __webpack_public_path__ + "static/media/holiday_vorden.261893df.jpg";